import styled, { css } from "styled-components";

export const StyledViewContainer = styled.div`
    box-sizing: border-box;
    ${p =>
        p.theme.sm.max(css`
            margin-bottom: -64px;
        `)}
    ${p =>
        p.theme.xs(css`
            margin: 0 -20px;
        `)}
`;